// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"31bf7a63","187":"24471426","239":"edc2b42c","453":"366359a2","455":"4f64cc62","796":"e2e6f81b","858":"d41fcbb2","906":"dc72f0fb","946":"b2ae6cdf","949":"7b1c4c4c"}[chunkId] + ".chunk.js";
};